import { useState } from "react";

interface HeroProps {
  onSearch: (q: string) => void;
}

export default function Hero({ onSearch }: HeroProps) {
  const [q, setQ] = useState("");

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(q.trim());
    document.getElementById("recommend")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="home" className="relative w-full min-h-[560px] md:min-h-[620px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=vibrant%20stylized%20manga%20comic%20art%20collage%20of%20energetic%20anime%20characters%20and%20dynamic%20action%20scenes%2C%20bold%20crimson%20red%20and%20warm%20amber%20gold%20palette%2C%20dramatic%20ink%20brush%20strokes%2C%20artistic%20illustration%20background%2C%20clean%20composition%20with%20space%20in%20center&width=1800&height=1000&seq=hero-131mh&orientation=landscape')",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>

      <div className="relative z-10 w-full mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24 text-center">
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500 text-background-50 text-xs md:text-sm font-medium mb-6 whitespace-nowrap">
          <i className="ri-heart-3-fill"></i>
          一生推的本命漫，都在这里
        </span>
        <h1 className="text-background-50 font-display text-3xl md:text-6xl leading-tight max-w-4xl mx-auto">
          找到你的下一部本命漫
          <span className="block text-accent-400 mt-2">入坑不踩雷</span>
        </h1>
        <p className="mt-5 text-background-100/95 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed">
          131漫画网按本命标准挑出入坑作，从画风到剧情都是能当本命的存在。
          不知道下一部追什么？看本命推荐列表，一生推的入坑作都在这里。
        </p>

        <form
          onSubmit={submit}
          className="mt-8 max-w-xl mx-auto flex flex-col sm:flex-row items-stretch sm:items-center gap-2 p-1.5 rounded-full bg-background-50/95 backdrop-blur"
        >
          <div className="flex items-center gap-2 px-4 py-2 flex-1">
            <i className="ri-search-line text-foreground-500 text-lg"></i>
            <input
              type="text"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="搜索画风、剧情或类型，比如：热血、治愈、恋爱"
              className="w-full bg-transparent outline-none text-sm text-foreground-900 placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            搜本命
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3 text-background-100 text-xs md:text-sm">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-sparkling-2-fill text-accent-400"></i> 186部本命漫
          </span>
          <span className="hidden sm:inline text-background-50/40">|</span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-flag-2-fill text-accent-400"></i> 8大类型精选
          </span>
          <span className="hidden sm:inline text-background-50/40">|</span>
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-thumb-up-fill text-accent-400"></i> 全网口碑口碑榜
          </span>
        </div>
      </div>
    </section>
  );
}